import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adobe-uxp-developer-tool"
    }}>{`Adobe UXP Developer Tool`}</h1>
    <p>{`The Adobe UXP Developer Tool makes it easy to create, load, debug, and package UXP-based plugins.`}</p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`The Adobe UXP Developer Tool allows you to manage plugins that you are developing for Photoshop (and other UXP-powered host applications). This tool makes it easy to create plugins based on templates, and also load and debug plugins that you're building.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p><strong parentName="p">{`IMPORTANT`}</strong>{`:
The Adobe UXP Developer Tool requires elevated privileges in order to function correctly. If your administrator does not enable your ability to elevate to Administrator privileges, you'll be unable to use this tool.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`The Adobe UXP Developer Tools can be installed from the Adobe Creative Cloud application. For more details on installation steps refer the `}<a parentName="p" {...{
        "href": "installation/"
      }}>{`Installation guide`}</a>{`. `}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "installation/"
      }}>{`Installation`}</a></p>
    <p>{`Installation walkthrough.    `}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "../guides/devtool/udt-walkthrough"
      }}>{`Walkthrough`}</a></p>
    <p>{`End-to-end tutorial, including creation of a plugin, and loading it into Photoshop.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "plugin-management/"
      }}>{`Plugin management`}</a></p>
    <p>{`Manage your plugins under active development.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "plugin-workflows/"
      }}>{`Plugin workflows`}</a></p>
    <p>{`Common workflows while building your plugin.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "working-with-react/"
      }}>{`Working with React`}</a></p>
    <p>{`Advanced workflows when working with React-based plugins.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      